/**
 * Returns the public href for a given path.
 * Previously handled v2 UI versioning, now returns path as-is.
 */
export function getPublicHref(path: string) {
  return path;
}
